import * as React from 'react';

import styles from './SearchItemLoader.module.scss';

const SearchItemLoader: React.FunctionComponent = () => {
  const { wrapper, picture, content, title, pillsWithPrice, pills, pill, priceWrapper, price, pricingType } = styles;
  return (
    <div className={wrapper}>
      <div className={picture} />
      <div className={content}>
        <div className={title} />
        <div className={pillsWithPrice}>
          <div className={pills}>
            <div className={pill} />
          </div>
          <div className={priceWrapper}>
            <div className={price} />
            <div className={pricingType} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SearchItemLoader;
